import { RequestDataSetting } from 'api/chat/setting/update-setting';

interface ISidebar {
  icon: string;
  title: string;
}

export const LIST_SIDEBAR: Array<ISidebar> = [
  {
    icon:
      'https://s3-alpha-sig.figma.com/img/a7a6/7f44/e69251ddae10903750d1fde64f11ac10?Expires=16' +
      '61731200&Signature=ZveCUvncCD9bDdfzJzmYJzXr2UXL5ykkvsmGYj5N1Oj3S7uOxkdKk5L1zLAufZgKVXz7BV1C8xPM' +
      'wjjhT5YLMmFvGfXSMnnN2ZkZfv6Jq6nzxPHjfL5sDps5lKM1SXxQe~qYAfkXp0iSZneudd0LoR50n2neqZuVO35YuJQHJi~J' +
      'LX-Vi8xe3cHExGP965~R5X8LIYcDSmglLzyovaZCCvy5cj4cxcSY4HbFZpBa9ghwK4kb22RLtjIXgIvwhQuxrIcebT5N-keb' +
      '1ldx4QLr7WbCpQWi4nz784jO2zvvfmeOI0h8G7wNE5peMfDPgl1y6cYIdf7Mxr~DMZQAeaKjNQ__&Key-Pair-Id=APKAINT' +
      'VSUGEWH5XD5UA',
    title: 'General',
  },
  {
    icon:
      'https://s3-alpha-sig.figma.com/img/5507/29c0/a419a656b9bb80694dc42e2092cdd288?Expires=166173120' +
      '0&Signature=DBt~mXF4qVypVnvLmlYwmO5Csrhh2acYqoUTqwIANbb468u5kiyT98frYrMgeoT9263PEsM6IlOpW2CvN37SkNiaq' +
      'w6iAl~OCiXstunhvNK3rRDtpUssIMzk7ucKdoqH3sLsYuMsFXbQJI9QjokkobSXvLhBq9OnxWmpyXRWq1pqsyTJnEUan7wWlSzuzv' +
      'fr2HFYkI4eNzoWJgOmmWBR1ZfWhzH4CSa1CZ1aHDQebGFTGRZiq6GONSFjWlfSi8xiy2OOs29EeXubeCjZasMUkqYz0Bk7Q922qmf' +
      'ySfbsch22jIerQJ4547o0-BEIt~Jr1vSD9Uv-xhLU8IB1U5za0w__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA',
    title: 'Profile & tagging',
  },
  {
    icon:
      'https://s3-alpha-sig.figma.com/img/ecbc/235b/8570c8d6ee22ba244e81dfe74cfed193?Expires=166173120' +
      '0&Signature=KJfq1YjOMJw3ikPr0LvazAj6hBUmX62VgWwHzG1f9lOYnFlJNEal~fKslE6jsUN5xamBv4aUYrInYY0EvgeoxOWFSZu' +
      'Uk~OX2aQGcxuUpml3h59ktRcj-ngX7OZz-NeDF~KhncXzDp9EZ7Luuywl5HeLCXvmuCNeK~gVF20zbkSCtpxcqwDw7XPsyYwRO23e-g' +
      '7I8RGh5I8axM0KtKJVRnVX9RhV8wNgwe8UWeCKqbdNXt7H7wCX1pFUVtYcPrNJquz2BBtW7AMwSLNYqzCdOLguZw7pijBqve46yfVCW' +
      'lUVZ10f93BNrfpl~bHBSE-Zsy86T~egZF4n5BiJXwiLCQ__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA',
    title: 'Appearance',
  },
  {
    icon:
      'https://s3-alpha-sig.figma.com/img/2f62/a7a5/2223d3a5d682920ced432f9f038f53ea?Expires=16611' +
      '26400&Signature=dZo9isX5m051ECGsvyvvxLIXU1twKY~GxX1wy~HP70X4nXEYSa3SGo2t-XLy4W-K-2YC4iPg5L-tzAPYG6' +
      'OiuvnoU7MY0bUkj-pmkeLnsCjCtrnirxkuWl4Z0irHsGWSkxeLzpLBXeVCfduYMfSUKDWlkHmqR5I6hkyMNVesjeZpBOF9Ew6D' +
      'Z2TttmS-Jtlw88NTMPFHDErbtSiRDJG2PRn47UZxFdnAt2ClWYRoNOSRHhph6aHCxo2PzU-Hv9-82yKXiO3sNbL8IfsUxnoKPN' +
      'xXZ6tGXFTLYOn5319vvObIbu1FcqcvV1OqRcNQKjfqdDqkciruk7l~NdPX7b8Fng__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA',
    title: 'Message',
  },
  {
    icon:
      'https://s3-alpha-sig.figma.com/img/55b9/25c5/b263dce01848a0a325ed55268cb6cc6b?Expires=1661126' +
      '400&Signature=WLONJoNJkBZEVOZQ-nECbmKRYbA1JQ7gegvmawc9kTELkMmeF6iGka7yEO7KvIvRNjSkPjQbwzK~jYb9SkeuUc' +
      'Qp2jd21jlYTMv3NllQMAZBh68bO5a09ydlK9qLCx6qlvPfR9G0OQ~OHTiyvShAS05~Jqpq324yulDqKoSK5AKLG65bczL0unzOPx' +
      'DjayC5J~B-uMbKoV8objU3HrYQwqC2-nkHJVH4YzVfLM~t5MN8GYaELK8bWOVTw21MHW1ytULR-QmCAnTz8AyIXrKJWCWGNj6gYB' +
      'SHQrfiI7P14Tqhg6IOkTzmjEuSYozxawu3rB6BCM5Q3zI6X67tGkmhvQ__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA',
    title: 'Notification',
  },
  {
    icon:
      'https://s3-alpha-sig.figma.com/img/0735/010b/490f594b0d890e4367f19537f3ab964b?Expires=166112640' +
      '0&Signature=FbRxMEMEdm3x8-I96IMy8nP5CODwB9oYFtJm-22CzsVgXL8KUOHtEpAa571bZg43IO8XWcZU~DOUpQdjBU41IAyPLbI' +
      'c9h300dzimvle1wFi3ti5dlAMMkwmAZ8ibmVUkXejG4datTXnpJcDEQ09EHzzv6FSUBu-IE~jTKUY5Rzi7~T7v0hbIWYN3OSQCIxeXk' +
      'zNqyhk-RqIORIStsmEW0LP~4f1TtLhf8T0SU01XWaLR9PMlNlp1UxkQOwGuuaH8n1Qr8b~RphRmC8Jl3dpi-qbV2gzEU1tAkYBBdsoX' +
      'KkvuuHd7hVyQ3mLR-tKAzYC5kKH2WE2Oj0RqS~LKYva1g__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA',
    title: 'Chat',
  },
];

export const IconProfile =
  'https://s3-alpha-sig.figma.com/img/3931/2fe2/ca052353d046e16409c65e00ff69e379?Expi' +
  'res=1661126400&Signature=f-XKuwgQU3hQ7jrUrvcYL10tnYIKE2WlPJ2Jxzs9J8cCZWiwC84t-rlwTp9T8GaKOB6mCDptwcFr~m3txKb8' +
  'CMUSIPrzNoZaygtY2vsD5r2HxXhczws7p5-onbC3eThzvbL7zsmodBdXJYpD2TpPqIDZ-EhYxMwCo8fqlH9jEP9cS1OSmYQA0umaUZxFSiP8O' +
  'xAnwE1vIJ1~8J1eW-BKR3Iy8pgidTOw1KUC7otI~RjCLu8yjjCzWjA2edQAbLGouBT1OxMkeGpczwXOvuHuIzkDdzRJYw6owcaCPOqPQHWCfJ' +
  'iX2ydVzwe32D-hf0rhWi13Xqrnd-sm5LPES8D7xw__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA';

export const listTitleNotification = (self: RequestDataSetting) => {
  return [
    {
      value: 'is_notify_message',
      label: 'Show browser notification when have new message',
      isCheckStatus: self.is_notify_message,
    },
    {
      value: 'is_notify_sound',
      label: 'Play a sound when a message is received ',
      isCheckStatus: self.is_notify_sound,
    },
    {
      value: 'is_show_sum_msg',
      label: 'Show sum message in browser ',
      isCheckStatus: self.is_show_sum_msg,
    },
    {
      value: 'is_notify_desktop',
      label: 'Allow desktop notifications',
      isCheckStatus: self.is_notify_desktop,
    },
  ];
};

export const colorAppearance = [
  '#743232a3',
  '#3fa13fad',
  '#6363a7',
  'rgb(129 129 38 / 75%)',
  'rgb(14 66 57 / 75%)',
  'blue',
];
